var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-stepper',{ref:"stepper",attrs:{"keep-alive":"","flat":"","header-nav":"","color":"primary","animated":""},model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }